import axiosStripePublicInstance from "../services/axiosStripePublicInstance";
import { COACH_CARD_UPDATE_SUCCESS } from "../entities/Endpoints";

export const coachCardUpdateApi = async (checkoutSessionId) => {
  try {
    const response = await axiosStripePublicInstance.post(
      `${COACH_CARD_UPDATE_SUCCESS}?checkoutSession_id=${checkoutSessionId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to update coach card.");
  }
};
